import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "pop-slippage",
  props: {
    show: Boolean
  },
  computed: {
    ...walletVuex.mapState(["isMobile", "netId", "isConnect"])
  },
  data() {
    return {
      selectSwitch: null,
      slippageNum: null
    };
  },
  watch: {
    show(bool) {
      if (bool) {
        this.selectSwitch = this.$parent.slippage;
        this.slippageNum = this.$parent.slippage;
      }
    }
  },
  methods: {
    onInput() {
      const regex = /^(?!0\d)(\d{1,2}(\.\d{0,4})?|50(\.0{1,4})?)$/;
      if (!regex.test(this.slippageNum) || parseFloat(this.slippageNum) > 50) {
        this.slippageNum = this.slippageNum.slice(0, -1);
      }
    },
    onClose() {
      this.$emit("update:show", false);
    },
    onSwitch(item) {
      this.selectSwitch = item;
      this.slippageNum = item;
    },
    onApply() {
      if (!this.slippageNum) {
        this.slippageNum = 1;
      }
      this.$parent.slippage = this.slippageNum;
      this.$parent.setSwitchInfo();
      localStorage.setItem("slippage", this.$parent.slippage);
      this.$emit("update:show", false);
    }
  }
};